import scrollToElement from "./scrollto";
document.querySelectorAll('.link--scroll-to').forEach(function (el) {
    el.addEventListener('click', function (event) {
        scrollToElement(document.querySelector(el.hash));
        event.preventDefault();
        setTimeout(function () { return document.location.hash = el.hash; }, 1000);
    });
});
